import { Refund } from './refund';
import { RefundType } from './refund_types';

export const defaultRefund: Refund = {
  type: RefundType.Refund,
  refund_amount: 0,
  credit_amount: 0
}

